<template>
  <div v-if="question.questionOptions.length > 0">
    <v-col cols="12" v-for="(option, idx) in question.questionOptions" :key="idx" class="px-0">
      <v-card outlined tile>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field dense outlined label="Option Text" @blur="ctrl.update(ctrl.formData)"
                placeholder="Option Text" v-model="option.optionContent[0].optionText" clearable>
              </v-text-field>
              <v-text-field dense outlined label="Option Help" @blur="ctrl.update(ctrl.formData)"
                placeholder="Option Help" v-model="option.optionContent[0].optionHelp" clearable>
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <div>Option Value: {{ option.answerBool }}</div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </div>

</template>

<script>
  // v-model="option.answer" for v-text-fields
  export default {
    name: "yes-no",
    props: {
      question: Object,
      updateQuestion: Function,
    },
    data() {
      return {
        ctrl: this.get_controller("questionnaire_question"),
        checked: false,
      };
    },
  };
</script>